import { PharmaCompanyForm } from '@/pages/pharma-companies/components/PharmaCompanyForm';
import { useParams } from '@tanstack/react-router';
import React from 'react';

export const PharmaCompanyDetailPage: React.FC = () => {
  const { pharmaCompanyId: idParam } = useParams({ strict: false }) as {
    pharmaCompanyId?: string;
  };
  const pharmaCompanyId = Number(idParam);

  if (!Number.isFinite(pharmaCompanyId)) {
    return (
      <div className="py-16 text-center text-muted-foreground">
        잘못된 제약사 ID입니다.
      </div>
    );
  }

  return <PharmaCompanyForm mode="edit" pharmaCompanyId={pharmaCompanyId} />;
};
